export default __webpack_public_path__ + "static/media/hungo-screenshot-02.26cba2e8.png";